import { ApplicationState } from '../redux/ApplicationState';
import { ExpensesDataSection } from '../redux/reducers/Expenses/expenses.model';
import { FormDataSection } from '../redux/reducers/FormsData/formsData.model';
import {
  expensesDataSectionOrder,
  formDataSectionOrder,
  getActiveFormSections,
} from '../redux/reducers/FormsData/formsData.sections';

const NEXT_BUTTON_HASH = 'next-btn';
const SECTION_OPEN_DELAY_MS = 200;

export const openNextFormSection = (currentSection: FormDataSection, state: ApplicationState): void => {
  const activeSections = getActiveFormSections(state);
  const activeSectionOrder = formDataSectionOrder.filter((section) => activeSections[section]);
  const currentSectionIndex = activeSectionOrder.indexOf(currentSection);
  const nextSection = activeSectionOrder[currentSectionIndex + 1];

  if (currentSectionIndex === -1 || !nextSection) {
    window.location.hash = NEXT_BUTTON_HASH;
    return;
  }

  window.setTimeout(() => {
    window.location.hash = nextSection;
  }, SECTION_OPEN_DELAY_MS);
};

export const openNextExpensesSection = (currentSection: ExpensesDataSection): void => {
  const currentSectionIndex = expensesDataSectionOrder.indexOf(currentSection);
  const nextSection = expensesDataSectionOrder[currentSectionIndex + 1];

  if (currentSectionIndex === -1 || !nextSection) {
    window.location.hash = NEXT_BUTTON_HASH;
    return;
  }

  window.setTimeout(() => {
    window.location.hash = nextSection;
  }, SECTION_OPEN_DELAY_MS);
};
